import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import {
  getTwilioAvailable,
  isRoleForActiveCompanyFBCollaboratorSelector,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { createSelector } from 'reselect';
import {
  SidebarTitleDefinition,
  SIDEBAR_MENU,
} from './BotBuilderSidebar/sidebar-menu';

const selectIsSysAdmin = (state: StoreState) => state.session.session.admin;

const getFilteredSidebarMenu = (
  isSysAdmin: boolean,
  featureFlags: ReturnType<typeof combinedFeatureFlagsSelector>,
  isTwillioAvailable: boolean,
  isFBCollaborators: boolean,
) => {
  const smsItemsByFeatureFlag = (section: SidebarTitleDefinition) => {
    if (section.id === 'SMS' && section.featureFlag) {
      return isTwillioAvailable || featureFlags[section.featureFlag];
    }
    return true;
  };

  const byHideFeatureFlag = (section: SidebarTitleDefinition) =>
    !(section.hideFeatureFlag && featureFlags[section.hideFeatureFlag]);

  const automationsByFeatureFlag = (section: SidebarTitleDefinition) => {
    return section.featureFlag !== 'automations' || featureFlags['automations'];
  };

  const mercuryByFeatureFlag = (section: SidebarTitleDefinition) => {
    return section.featureFlag !== 'mercury' || featureFlags['mercury'];
  };

  const filteredSideBar = SIDEBAR_MENU.filter(byHideFeatureFlag)
    .filter(smsItemsByFeatureFlag)
    .filter(automationsByFeatureFlag)
    .filter(mercuryByFeatureFlag);

  return filteredSideBar.map(sidebarSection => {
    const menuItems = sidebarSection.menuItems.filter(menuItem => {
      if (menuItem.hideForFBCollaborators) {
        return !isFBCollaborators;
      }

      if (menuItem.hideFeatureFlag && !featureFlags[menuItem.hideFeatureFlag]) {
        return false;
      }

      if (menuItem.mustBeSysAdmin) {
        return isSysAdmin;
      }

      return true;
    });

    return {
      ...sidebarSection,
      menuItems,
    };
  });
};

export const filteredSidebarMenuSelector = createSelector(
  [
    selectIsSysAdmin,
    combinedFeatureFlagsSelector,
    getTwilioAvailable,
    isRoleForActiveCompanyFBCollaboratorSelector,
  ],
  getFilteredSidebarMenu,
);
